<template>
    <div class="px-5 d2d-onboarding">
        <div class="row">
            <div class="col-md-12 pt-4 d2d-header pb-5">
                <h1>Valid Documents</h1>
            </div>
            <div class="col-md-12 py-3 mt-3 mb-2">
                <p>
                    All documents need to be definitive proof that the customer was a qualified SPEQ customer. For most customers, their government issued IDs or licenses will be required. Examples are below
                </p>
                <br>
                <p>
                    *Please note, images must be clear and legible
                </p>
                <p>
                    *SilencerCo will review submitted photos periodically to make sure the program is not being abused.
                </p>
                <br>
                <p>
                    It is your responsibility to collect this documentation at time of sale.
                </p>
                
                <div class="row align-items-center mb-5">
                    <div class="col-md-8">
                        <p>
                            Law Enforcement - a personal or government ID and/or officer's badge identifying them as law enforcement.  
                        </p>
                    </div>
                    <div class="col-md-4">
                        <div class="d-flex align-items-center">
                            <img src="/speq_valid_documents/law_enforcement_badge.jpg" style="width: 180px;">
                            <img src="/speq_valid_documents/law_enforcement_badge_&_id.jpg" style="width: 250px;">
                        </div>
                    </div>
                </div>

                <div class="row align-items-center mb-5">
                    <div class="col-md-8">
                        <p>
                            Military / Uniformed Service - a uniformed services identification card.
                        </p>
                    </div>
                    <div class="col-md-4">
                        <div class="d-flex align-items-center">
                            <img src="/speq_valid_documents/uniformed_services_identification_card.jpeg" style="width: 210px;">
                        </div>
                    </div>
                </div>

                <div class="row align-items-center mb-5">
                    <div class="col-md-8">
                        <p>
                            Federal Fight Deck Officer - a personal or government ID or badge identifying the person as an FDO.
                        </p>
                    </div>
                    <div class="col-md-4">
                        <div class="d-flex align-items-center">
                            <img src="/speq_valid_documents/federal_flight_deck_officer_badge.jpeg" style="width: 130px;">
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-8">
                        <p>
                            Fire Rescue / EMT / First Responder - a personal or employee ID identifying them as a first responder, or other valid proof of identification.
                        </p>
                        <p>
                            Private Security - a personal or employee ID and/or license identifying them as private security. 
                        </p>
                        <p>
                            Other - Any applicable ID proving SPEQ qualification
                        </p>
                    </div>
                    <div class="col-md-4">
                        
                    </div>
                </div>
                <br>
                <p>
                    <b>What if the customer refused to let me take a picture of their credentials?</b> 
                    If this happens you can fill out a <a href="/speq_valid_documents/silencerco_speq_affidavit.pdf" target="_blank">SPEQ Affidavit</a> form and upload it as proof. All fields are required. 
                </p>
                
            </div>
        </div>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore, mapGetters } from "vuex";
export default {
    props: [],
    emits: [],
    components: {},
    setup() {
        const store = useStore();
        let currentLocation = computed(function () {
            return store.state.currentLocation;
        });

        let user = computed(function () {
            return store.state.user;
        });

        return {
            store,
            user,
            currentLocation
        };
    },
    data() {
        return {
            locationId: "",
            silencers: {
                rifle: {
                    name: "Rifle Silencers",
                    data: [
                        {
                            name: "Scythe-Ti",
                            sku: "SU5328",
                            commission: "200",
                            starred: true,
                            high_earner: false,
                        },
                        {
                            name: "Omega 300 DTM",
                            sku: "SU4735",
                            commission: "200",
                            starred: true,
                            high_earner: true,
                        },
                        {
                            name: "Omega 36M",
                            sku: "SU4735",
                            commission: "200",
                            starred: true,
                            high_earner: true,
                        },
                        {
                            name: "Hybrid 46 DTM",
                            sku: "SU5107",
                            commission: "200",
                            starred: true,
                            high_earner: false,
                        },
                        {
                            name: "Hybrid 46M",
                            sku: "SU5107",
                            commission: "200",
                            starred: true,
                            high_earner: false,
                        },
                        {
                            name: "Chimera 300",
                            sku: "SU2616",
                            commission: "175",
                            starred: false,
                            high_earner: false,
                        },
                        {
                            name: "Saker 556K ASR",
                            sku: "SU2256",
                            commission: "175",
                            starred: false,
                            high_earner: false,
                        },
                        {
                            name: "Velos LBP",
                            sku: "SU5059",
                            commission: "200",
                            starred: true,
                            high_earner: false,
                        },
                    ],
                },
                pistol: {
                    name: "Pistol Silencers",
                    data: [
                        {
                            name: "OSPREY 45 2.0",
                            sku: "SU5185",
                            commission: "150",
                            starred: false,
                            high_earner: false,
                        },
                        {
                            name: "OSPREY 9 2.0",
                            sku: "SU5184",
                            commission: "150",
                            starred: false,
                            high_earner: false,
                        },
                        {
                            name: "OMEGA 45K",
                            sku: "SU2254",
                            commission: "130",
                            starred: false,
                            high_earner: false,
                        },
                        {
                            name: "OMEGA 9K",
                            sku: "SU1544",
                            commission: "130",
                            starred: false,
                            high_earner: false,
                        },
                    ],
                },
                rimfire: {
                    name: "Rimfire Silencers",
                    data: [
                        {
                            name: "SPARROW 22",
                            sku: "SU75",
                            commission: "60",
                            starred: false,
                            high_earner: false,
                        },
                        {
                            name: "SWITCHBACK",
                            sku: "SU5085",
                            commission: "100",
                            starred: false,
                            high_earner: false,
                        },
                    ],
                },
                shotgun: {
                    name: "Shotgun Silencers",
                    data: [
                        {
                            name: "SALVO 12",
                            sku: "SU823",
                            commission: "200",
                            starred: false,
                            high_earner: false,
                        },
                    ],
                },
            },
            locations: [],
        };
    },
    mounted() {
        this.getLocations();
    },
    methods: {
        getLocations() {
            axios
                .post("/api/get-locations", { user_id: this.user.id })
                .then((data) => {
                    this.locations = data.data.result;
                    if (data.data.result.length == 1) {
                        this.locationId = data.data.result[0].id;
                    }
                });
        },
        goToOnboarding(id) {
            this.$router.push({
                name: "directToDealerOnboarding",
                params: { id: id },
            });
        },
    },
    computed: {
        currentLocationIsOnboarded() {
            if (this.locationId != "" && this.locationId != null) {
                let index = this.locations.findIndex(
                    (item) => item.id == this.locationId
                );
                if (index != -1) {
                    if (
                        this.locations[index].direct_to_dealer_onboarding !=
                        null
                    ) {
                        if (
                            this.locations[index].direct_to_dealer_onboarding
                                .signing_session_data != null
                        ) {
                            return true;
                        }
                    }
                }
            }
            return false;
        },
        acceptSpeqInvite() {
            this.currentLocation.speq_invite_status = 3; //ACCEPTED
            this.store.dispatch("acceptSpeqInvite", this.currentLocation.id);
        },
    },
};
</script>
<style scoped lang="scss">
.btn-join-d2d {
    font-size: 12px;
    word-wrap: break-word;
    white-space: break-spaces;
}
.btn-join-d2d:hover,
.btn-join-d2d.active {
    color: white !important;
}

.d2d-header {
    text-align: center;
    background: #ededed;
    padding: 20px;
    border-radius: 30px;
    h1 {
        font-size: 2rem;
        color: #000000;
    }
    .d2d-h-subtitle {
        font-size: 1.6rem;
        font-weight: 600;
        color: #000000;
        span {
            font-weight: 800;
            font-family: "TT-Norms-ExtraBold";
        }
    }
}

.d2d-onboarding {
    @media (max-width: 600px) {
        width: 100%;
        padding: 1rem !important;
    }
    width: 80%;
    margin: auto;
    h2 {
        font-size: 2rem;
        color: #000000;
    }

    .step-container {
        display: flex;
        gap: 20px;
        margin-top: 10px;
        margin-bottom: 20px;
        .step-sub-container {
            @media (max-width: 600px) {
                width: 100%;
                padding: 1rem !important;
            }
            flex: 1;
            padding: 25px;
            background: #2d2b29;
            display: flex;
            color: white;
            gap: 20px;
            border-radius: 12px;
            width: 49%;
            .step-holder {
                .step-text {
                    font-size: 28px;
                    font-family: "TT-Norms-ExtraBold";
                }
                .step-number {
                    font-size: 50px;
                    color: #ff7f00;
                    font-family: "TT-Norms-ExtraBold";
                    margin-top: -25px;
                }
            }
            .step-info {
                width: 80%;
                margin: auto;
                font-size: 22px;
                span {
                    color: #ff7f00;
                }
            }
        }
    }

    .d2d-btn {
        width: 225px;
        height: 45px;
        border-radius: 50px;
        background: #ff7f00;
        color: white;
        border-color: #ff7f00;
        font-weight: 500;
        border: 1px solid #ff7f00;
        padding: 10px 30px;
        &:hover {
            color: #ff7f00;
            background-color: transparent;
        }
        font-family: "TT-Norms-ExtraBold";
    }

    a {
        color: #ff7f00;
        text-decoration: none;
    }

    ol {
        padding: 0;
        font-size: 18px;
        line-height: 2rem;
        color: black;
        padding-left: 5px;
    }
    p {
        color: black;
    }
    h2 {
        span {
            color: #ff7f00;
        }
    }
    .accordion-button {
        font-size: 25px;
    }

    .accordion {
        max-width: 550px;
        margin-left: 45px;
        margin-top: 10px;
        @media (max-width: 600px) {
            margin-left: 0px;
        }
    }

    .accordion-button:not(.collapsed) {
        background: none;
        color: #ff7f00;
    }
    .accordion-button.collapsed::after {
        content: "";
        display: block;
        box-sizing: border-box;
        position: absolute;
        width: 15px;
        height: 15px;
        border-bottom: 3px solid;
        border-right: 3px solid;
        transform: rotate(45deg);
        left: 4px;
        top: 30%;
        background-image: unset;
        right: 25px;
        color: #ff7f00;
    }

    .accordion-button:not(.collapsed)::after {
        content: "";
        display: block;
        box-sizing: border-box;
        position: absolute;
        width: 15px;
        height: 15px;
        border-bottom: 3px solid;
        border-right: 3px solid;
        transform: rotate(225deg);
        left: 4px;
        top: 40%;
        background-image: unset;
        right: 25px;
        color: #ff7f00;
    }
    .accordion-item {
        border: unset;
        border-top: 2px solid #efefefef;
    }
    .theader {
        font-size: 18px;
        color: #bcbcbc;
        margin-bottom: 5px;
    }
    .tbody {
        font-size: 18px;
        color: #000000;
    }
    .starred {
        vertical-align: baseline;
        margin-left: 5px;
        margin-right: 5px;
        width: 12px;
    }
    .high-earner {
        font-size: 12px;
        color: #ff7f00;
        font-style: italic;
    }
    .accordion-body {
        .trow {
            border-top: 1px solid #fefe;
            padding-top: 5px;
            padding-bottom: 5px;
        }
    }
}
.location-name {
    color: #000000 !important;
    text-transform: uppercase;
    font-weight: 800;
    font-family: "TT-Norms-ExtraBold";
}

.bold {
    font-family: "TT-Norms-ExtraBold";
    color: #000000 !important;
}

.sign-up-badge {
    background-color: #ff7f00 !important;
    font-family: "TT-Norms-ExtraBold";
    padding: 5px 20px 5px 20px !important;
    font-size: 12px;
}

.sign-up-badge:hover {
    cursor: pointer;
}
</style>
